
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/accessibility-statement",
      function () {
        return require("private-next-pages/about/accessibility-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/accessibility-statement"])
      });
    }
  